var _rect, _rect2, _rect3, _rect4, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSirDeClame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 80,
    viewBox: "0 0 76 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 58.2603,
    y: 21,
    width: 16.7397,
    height: 37,
    stroke: "black",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 21,
    width: 17.7808,
    height: 37,
    stroke: "black",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19.7397,
    y: 21,
    width: 17.7808,
    height: 37,
    stroke: "black",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38.4795,
    y: 21,
    width: 17.7808,
    height: 37,
    stroke: "black",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2177 32.2727V41H10.1609V33.3807H10.1097L7.97905 34.7955V33.7216L10.1609 32.2727H11.2177Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1642 39.2102V38.3409L66.9994 32.2727H67.6301V33.6193H67.204L64.3062 38.2045V38.2727H69.471V39.2102H63.1642ZM67.2722 41V38.946V38.5412V32.2727H68.2778V41H67.2722Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5368 41.1193C45.9743 41.1193 45.4729 41.0227 45.0326 40.8295C44.5951 40.6364 44.2471 40.3679 43.9885 40.0241C43.7329 39.6776 43.5937 39.2756 43.5709 38.8182H44.6448C44.6675 39.0994 44.7641 39.3423 44.9346 39.5469C45.105 39.7486 45.328 39.9048 45.6036 40.0156C45.8792 40.1264 46.1846 40.1818 46.5198 40.1818C46.8948 40.1818 47.2272 40.1165 47.517 39.9858C47.8067 39.8551 48.034 39.6733 48.1988 39.4403C48.3635 39.2074 48.4459 38.9375 48.4459 38.6307C48.4459 38.3097 48.3664 38.027 48.2073 37.7827C48.0482 37.5355 47.8153 37.3423 47.5084 37.2031C47.2016 37.0639 46.8266 36.9943 46.3834 36.9943H45.6846V36.0568H46.3834C46.73 36.0568 47.034 35.9943 47.2954 35.8693C47.5596 35.7443 47.7655 35.5682 47.9133 35.3409C48.0638 35.1136 48.1391 34.8466 48.1391 34.5398C48.1391 34.2443 48.0738 33.9872 47.9431 33.7685C47.8124 33.5497 47.6278 33.3793 47.3891 33.2571C47.1533 33.1349 46.8749 33.0739 46.5539 33.0739C46.2528 33.0739 45.9687 33.1293 45.7016 33.2401C45.4374 33.348 45.2215 33.5057 45.0539 33.7131C44.8863 33.9176 44.7954 34.1648 44.7812 34.4545H43.7584C43.7755 33.9972 43.9133 33.5966 44.1718 33.2528C44.4303 32.9062 44.7684 32.6364 45.186 32.4432C45.6064 32.25 46.0681 32.1534 46.5709 32.1534C47.1107 32.1534 47.5738 32.2628 47.9601 32.4815C48.3465 32.6974 48.6434 32.983 48.8508 33.3381C49.0582 33.6932 49.1618 34.0767 49.1618 34.4886C49.1618 34.9801 49.0326 35.3991 48.7741 35.7457C48.5184 36.0923 48.1704 36.3324 47.73 36.4659V36.5341C48.2812 36.625 48.7116 36.8594 49.0212 37.2372C49.3309 37.6122 49.4857 38.0767 49.4857 38.6307C49.4857 39.1051 49.3564 39.5312 49.0979 39.9091C48.8422 40.2841 48.4928 40.5795 48.0496 40.7955C47.6064 41.0114 47.1022 41.1193 46.5368 41.1193Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8892 41V40.233L28.7699 37.0795C29.108 36.7102 29.3864 36.3892 29.6052 36.1165C29.8239 35.8409 29.9858 35.5824 30.091 35.3409C30.1989 35.0966 30.2529 34.8409 30.2529 34.5739C30.2529 34.267 30.179 34.0014 30.0313 33.777C29.8864 33.5526 29.6875 33.3793 29.4347 33.2571C29.1819 33.1349 28.8978 33.0739 28.5824 33.0739C28.2472 33.0739 27.9546 33.1435 27.7046 33.2827C27.4574 33.419 27.2657 33.6108 27.1293 33.858C26.9958 34.1051 26.929 34.3949 26.929 34.7273H25.9233C25.9233 34.2159 26.0412 33.767 26.277 33.3807C26.5128 32.9943 26.8339 32.6932 27.2401 32.4773C27.6492 32.2614 28.108 32.1534 28.6165 32.1534C29.1279 32.1534 29.581 32.2614 29.9759 32.4773C30.3708 32.6932 30.6804 32.9844 30.9049 33.3509C31.1293 33.7173 31.2415 34.125 31.2415 34.5739C31.2415 34.8949 31.1833 35.2088 31.0668 35.5156C30.9532 35.8196 30.7543 36.1591 30.4702 36.5341C30.189 36.9062 29.7983 37.3608 29.2983 37.8977L27.3381 39.9943V40.0625H31.3949V41H25.8892Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSirDeClame);
export default __webpack_public_path__ + "static/media/sir_de_clame.73e320dbf451458a028e5d86ff778090.svg";
export { ForwardRef as ReactComponent };